import api from '@/api/api';

const sessionTranscriptionDomain = (sessionId: string) =>
	`/session/${sessionId}/transcription`;

const postToken = async (
	sessionId: string,
): Promise<SessionTranscription.GrantDeepgramTokenResponse> => {
	const { data } =
		await api.post<SessionTranscription.GrantDeepgramTokenResponse>(
			`${sessionTranscriptionDomain(sessionId)}/token`,
		);
	return data;
};

const patchFragments = async (
	sessionId: string,
	body: SessionTranscription.PatchFragmentsBody,
): Promise<void> => {
	await api.patch(`${sessionTranscriptionDomain(sessionId)}/fragments`, body);
};

const SessionTranscriptionService = {
	postToken,
	patchFragments,
};

export { SessionTranscriptionService };
